// We use a symbol property name instead of { _type: Brand }, because that would show up in IDE suggestions,
// while internal symbols do not.
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

//# sourceMappingURL=opaque.js.map